import { render, staticRenderFns } from "./SiderRouteInfo.vue?vue&type=template&id=2df39dfc&scoped=true&"
import script from "./SiderRouteInfo.vue?vue&type=script&lang=js&"
export * from "./SiderRouteInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df39dfc",
  null
  
)

export default component.exports